import { brands, dark, light } from "@battmobility/fleet-design-tokens";
import type { Brand } from "@/types/brand.types";
import type { PaletteOptions } from "@mui/material/styles";

export function mapTokensToPalette(
	brand: Brand = "batt-b2b",
	mode: "light" | "dark" = "light"
): PaletteOptions {
	const modeTokens = mode === "light" ? light : dark;
	const brandTokens = brands[brand];

	return {
		mode,
		primary: {
			...brandTokens.primary,
			...brandTokens.primary.shades,
			contrastText: brandTokens.primary.contrast,
		},
		secondary: {
			...modeTokens.secondary,
			...modeTokens.secondary.shades,
			contrastText: modeTokens.secondary.contrast,
		},
		error: {
			...modeTokens.error,
			...modeTokens.error.shades,
			contrastText: modeTokens.error.contrast,
		},
		warning: {
			...modeTokens.warning,
			...modeTokens.warning.shades,
			contrastText: modeTokens.warning.contrast,
		},
		info: {
			...modeTokens.info,
			...modeTokens.info.shades,
			contrastText: modeTokens.info.contrast,
		},
		success: {
			...modeTokens.success,
			...modeTokens.success.shades,
			contrastText: modeTokens.success.contrast,
		},
		grey: modeTokens.grey,
		text: {
			primary: modeTokens.text.primary,
			secondary: modeTokens.text.secondary,
			disabled: modeTokens.text.disabled,
		},
		background: modeTokens.background,
		divider: modeTokens.divider,
		action: modeTokens.action,
		common: {
			black: modeTokens.common.black["100p"],
			white: modeTokens.common.white["100p"],
		},
		neutral: modeTokens.neutral,
		// Component-specific colors
		OutlinedInput: {
			border: modeTokens.divider,
		},
	};
}
